import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { toast } from 'react-toastify'
import { ApiService } from "../services/apiServices";
import DataContext from "../context";

const WalletModal = () => {
    const contextValues = useContext(DataContext);
    const userSession = {};
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [paymentmode, setpaymentmode] = useState("")
    const [showcardstate, setshowcradstate] = useState(false)
    const [savedcarddata, setsavedcarddata] = useState([])
    const [selectedcardid, setselectedcardid] = useState("")
    const [addnewcard, setaddnewcard] = useState(false)
    const [cardamount, setcardamount] = useState("")
    const [cardState, setCardState] = useState({
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        focus: "",
        save_card: 0
    });
    const didMountRef = useRef(true);
    useEffect(() => {
        if (didMountRef.current) {
            ApiService.fetchData("user-savedc-cards").then((res) => {
                if (res?.status === "success") {
                    setsavedcarddata(res?.cards)
                }
            })
        }
        didMountRef.current = false;
        if (cardamount < 10 && cardState !== "") {
            setpaymentmode("")
        }
    }, [cardamount])

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;
        if (name === 'number') {
            const numberWithoutSpaces = value.replace(/\s/g, '');
            updatedValue = numberWithoutSpaces.replace(/\D/g, '');
            updatedValue = updatedValue.replace(/[^\d]/g, '');
            updatedValue = updatedValue.replace(/(.{4})/g, '$1 ').trim();
            if (updatedValue.length > 20) {
                return false;
            }
        } else if (name === 'expiry') {
            updatedValue = value.replace(/[^\d\/]/g, '');

            if (updatedValue.length === 2 && !updatedValue.includes('/')) {
                updatedValue += '/';
            }
        } else if (name === 'cvc') {
            if (updatedValue.length > 4) {
                return false;
            }
        }
        setCardState({
            ...cardState,
            [name]: updatedValue
        });

    };
    const handleInputFocus = (e) => {
        setCardState((prev) => ({ ...prev, focus: e.target.name }));
    };



    const cardOption = (e) => {
        if (cardamount !== "") {
            if (Number(cardamount) >= 10) {
                setpaymentmode("card")
            } else {
                toast.error("You can  add minimum amount of  $10 in your wallet")
                return
            }
        } else {
            toast.error("Please Enter Amount Before Going to Payment Mode ")
            return
        }
    }

    const savecarddetail = (e) => {
        if (e.target.checked) {
            setCardState({
                ...cardState,
                ["save_card"]: 1
            });
        } else {
            setCardState({
                ...cardState,
                ["save_card"]: 0
            });
        }
    }


    const selectedcarddetail = (item) => {
        setselectedcardid(item?.ucd_four_number)
        const clickedCard = savedcarddata.find(card => card.ucd_four_number === item?.ucd_four_number);
        if (clickedCard) {
            setshowcradstate(true)
            setaddnewcard(false)
            setCardState({
                number: clickedCard?.ucd_four_number,
                save_card: 0,
                ucd_id: clickedCard?.ucd_id
            })
        }
        else {
            toast.error("Card not found or Transaction not possible with that card ")
        }
    }

    const addnewcarddetailfn = () => {
        setaddnewcard(true);
        setselectedcardid("");
        setshowcradstate(false);
        setCardState({
            number: "",
            name: "",
            expiry: "",
            cvc: "",
            name: "",
            focus: "",
            save_card: 0
        })
    }
    const handlesavedcard = (e, item) => {
        const { name, value } = e.target;
        let updatedValue = value;
        if (name === "cvc") {
            if (updatedValue.length > 3) {
                toast.error("CVC number cannot exceed with 3 digits")
                return false
            } else if (updatedValue.length === 3) {
                setCardState((prevCardState) => ({
                    ...prevCardState,
                    cvc: updatedValue,
                    save_card: 1,
                }));
            }
        }
    }

    const cardInage = (type) => {
        switch (type) {
            case 'Visa':
                return ('/img/vcard.png');
                break;
            case 'MasterCard':
                return ('/img/mcard.png');
                break;
            case 'American Express':
                return ('/img/amex.png');
                break;
            case 'Discover':
                return ('/img/dcard.png');
                break;
            case 'atm':
                return ('/img/atmcards.png');
            case 'JCB':
                return ('/img/jcard.png');
                break;
            default:
                return ('/img/ucard.png');
        }
    }

    const addMoneyToWalletBySavedCard = () => {
        if (cardState?.cvc?.length != 3) {
            toast.error('Please enter valid cvc')
            return false;
        }
        setSpinnerLoading(true)
        const dataString = {
            user_id: userSession.user_id,
            uw_amount_add: cardamount,
            userSession: userSession,
            cvc: cardState.cvc,
            name: cardState.name,
            ucd_id: cardState.ucd_id,
            trans_payment_method: paymentmode,
            uw_add_type: paymentmode === "card" ? 1 : paymentmode === "paypal" ? 2 : "",
            save_card: cardState.save_card
        }

        ApiService.postData('create-wallet-card-token', dataString).then((res) => {
            if (res.status === 'success') {
                toast.success("Money has been suucessfulley added to your wallet")
                setSpinnerLoading(false)
                setTimeout(() => {
                    window.location.reload();
                }, 1000);

            } else {
                setSpinnerLoading(false)
                toast.error(res.message)
            }
        })
    }

    const addMoneyToWalletByNewCard = () => {
        if (cardState.number === '') {
            toast.error('Please enter card number')
            return false;
        } else if (cardState.number.length > 19 || cardState.number.length < 19) {
            toast.error('Please enter valid card details')
            return false;
        }

        if (cardState.expiry === '') {
            toast.error('Please enter expiry date')
            return false;
        }
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear() % 100;
        const currentMonth = currentDate.getMonth() + 1;
        const [inputMonth, inputYear] = cardState.expiry.split('/').map(Number);
        const isValidDate = inputYear > currentYear || (inputYear === currentYear && inputMonth <= currentMonth);
        if (!isValidDate) {
            toast.error('Please enter valid expiry')
            return false;
        }

        if (cardState.cvc.length != 3) {
            toast.error('Please enter valid cvc')
            return false;
        }
        setSpinnerLoading(true)
        const dataString = {
            user_id: userSession.user_id,
            uw_amount_add: cardamount,
            userSession: userSession,
            card_number: Number(cardState.number.replace(/\s/g, '')),
            exp_month: inputMonth,
            exp_year: inputYear,
            cvc: cardState.cvc,
            name: cardState.name,
            ucd_id: 0,
            trans_payment_method: paymentmode,
            uw_add_type: paymentmode === "card" ? 1 : paymentmode === "paypal" ? 2 : "",
            save_card: cardState.save_card
        }

        ApiService.postData('create-wallet-card-token', dataString).then((res) => {
            if (res.status === 'success') {
                toast.success("Money has been suucessfulley added to your wallet")
                setSpinnerLoading(false)
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                setSpinnerLoading(false)
                toast.error(res.message)
            }
        })
    }

    const processToCard = () => {
        if (cardamount !== "") {
            if (Number(cardamount) >= 10) {
                setpaymentmode("card")
                setaddnewcard(true)
            } else {
                toast.error("You can  add minimum amount of  $10 in your wallet")
                return
            }
        } else {
            toast.error("Please Enter Amount Before Going to Payment Mode ")
            return
        }

    }

    const toggleWalletModal = () => {
        contextValues.setToggleWalletModal(!contextValues.toggleWalletModal)
    }
    return (
        <>
            <Modal show={contextValues.toggleWalletModal} onHide={() => toggleWalletModal()} className='addressModal bottom'>
                <div className='addressModalContent'>
                    <button type="button" className="addressModalclose" onClick={() => { toggleWalletModal() }}><i className="ri-close-line"></i></button>
                    <div className='addressModalContentInner'>
                        <div className="checkoutPanel-card">
                            {paymentmode === "" ?
                                <div className="form-group mb-15">
                                    <h6>Amount</h6>
                                    <div className="mt-3">
                                        <form>
                                            <div className="mb-0">
                                                <input
                                                    type="number"
                                                    name="amount"
                                                    className="form-control"
                                                    placeholder="Add Amount"
                                                    value={cardamount}
                                                    onChange={(e) => { setcardamount(e.target.value) }}
                                                    onFocus={handleInputFocus}
                                                    required
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                :
                                paymentmode === "card" ?
                                    <div className="checkbox mb-50">
                                        {savedcarddata?.length > 0 ? <>
                                            {savedcarddata?.map((items, index) => {
                                                return (
                                                    <div className="cardsavebox" key={index}>
                                                        <div className={selectedcardid === items.ucd_four_number ? "cardsaveboxnu active" : "cardsaveboxnu"} onClick={(e) => selectedcarddetail(items)}>
                                                            <div className="cardsavebox-icon">
                                                                <img alt="Daadi's Kitchen" src={cardInage(items?.ucd_card_type)} style={{ width: "40px", marginTop: "7px" }}></img>
                                                            </div>
                                                            <div className="cardsavebox-number">Ending with {items?.ucd_four_number}</div>
                                                            <img alt="Daadi's Kitchen" src="/img/correct.png" className="cardsaveboxselect"></img>
                                                        </div>
                                                        {cardState?.number === items?.ucd_four_number ? <>
                                                            <div className="row mt-3">
                                                                <div className="col-lg-12 ">
                                                                    <div className="crdform">
                                                                        <label>CVC</label>
                                                                    </div>
                                                                    <div className="crdform">
                                                                        <input type="number" name="cvc"
                                                                            placeholder="CVC"
                                                                            pattern="\d{3,4}"
                                                                            value={cardState?.cvc}
                                                                            onChange={(e) => { handlesavedcard(e, items) }}
                                                                            onFocus={handleInputFocus}
                                                                            required></input>
                                                                        <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cvv.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </> : ""}
                                                    </div>
                                                )
                                            })}
                                            <div className="cardsavebox" onClick={() => { addnewcarddetailfn() }}>
                                                <div className={addnewcard ? "cardsaveboxnu active" : "cardsaveboxnu"}>
                                                    <div className="cardsavebox-icon"><img alt="Daadi's Kitchen" src="/img/atmcards.png" style={{ width: "40px", marginTop: "7px" }}></img></div>
                                                    <div className="cardsavebox-number">Use a different card</div>
                                                    <img alt="Daadi's Kitchen" src="/img/correct.png" className="cardsaveboxselect"></img>
                                                </div>
                                            </div>
                                            {addnewcard ?
                                                <div className="carddetal mt-3">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="crdform">
                                                                <label>Card Number</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="text"
                                                                    name="number"
                                                                    placeholder="Card Number"
                                                                    value={cardState.number}
                                                                    onChange={handleInputChange}
                                                                    onFocus={handleInputFocus}
                                                                    required></input>
                                                                <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cradicon.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="crdform">
                                                                <label>Expiry date</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="text"
                                                                    name="expiry"
                                                                    placeholder="Valid Thru"
                                                                    pattern="\d\d/\d\d"
                                                                    value={cardState.expiry}
                                                                    onChange={handleInputChange}
                                                                    onFocus={handleInputFocus}
                                                                    required></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="crdform">
                                                                <label>CVC</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="number"
                                                                    name="cvc"
                                                                    placeholder="CVC"
                                                                    pattern="\d{3,4}"
                                                                    value={cardState.cvc}
                                                                    onChange={handleInputChange}
                                                                    onFocus={handleInputFocus}
                                                                    required></input>
                                                                <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cvv.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="crdform checkboxinput mb-3">
                                                                <input type="checkbox" onChange={(e) => { savecarddetail(e) }}></input>
                                                                Save card for next time
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ""}
                                        </> : <>
                                            {!showcardstate ? <>
                                                <div className="carddetal">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="crdform">
                                                                <label>Card Number</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="text"
                                                                    name="number"
                                                                    placeholder="Card Number"
                                                                    value={cardState.number}
                                                                    onChange={handleInputChange}
                                                                    onFocus={handleInputFocus}
                                                                    required></input>
                                                                <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cradicon.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="crdform">
                                                                <label>Expiry date</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="text"
                                                                    name="expiry"
                                                                    placeholder="Valid Thru"
                                                                    pattern="\d\d/\d\d"
                                                                    value={cardState.expiry}
                                                                    onChange={handleInputChange}
                                                                    onFocus={handleInputFocus}
                                                                    required></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="crdform">
                                                                <label>CVV</label>
                                                            </div>
                                                            <div className="crdform mb-3">
                                                                <input type="number"
                                                                    name="cvc"
                                                                    placeholder="CVC"
                                                                    pattern="\d{3,4}"
                                                                    value={cardState.cvc}
                                                                    onChange={handleInputChange}
                                                                    onFocus={handleInputFocus}
                                                                    required></input>
                                                                <div className="cicon"><img alt="Daadi's Kitchen" src="/img/cvv.svg" height={45} style={{ borderRadius: '4px' }}></img></div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="crdform checkboxinput mb-3">
                                                                <input type="checkbox" onChange={(e) => { savecarddetail(e) }}></input>
                                                                Save card for next time
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : ""}
                                        </>}
                                    </div> : null
                            }
                            {paymentmode === "card" ?
                                <div className="checkout-footer p-0">
                                    <div className="p-15">
                                        {showcardstate ?
                                            <button type="button" className="btn btn-primary btn-lg btn-full" disabled={spinnerLoading} onClick={(e) => addMoneyToWalletBySavedCard()}>{spinnerLoading ? (<img src="/img/loder01.gif" width="60px" height="11px" />) : 'Add Payment to Wallet'}</button>
                                            :
                                            <button type="button" className="btn btn-primary btn-lg btn-full" disabled={spinnerLoading} onClick={(e) => addMoneyToWalletByNewCard()}>{spinnerLoading ? (<img src="/img/loder01.gif" width="60px" height="11px" />) : 'Add Payment to Wallet'}</button>
                                        }
                                    </div>
                                </div>
                                :
                                <div className="form-group">
                                    <button type="button" className="btn btn-primary btn-lg btn-full" onClick={(e) => processToCard()}>Add Payment to Wallet</button>
                                </div>
                            } 
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
};
export default WalletModal;
